import NofoundImg from '../../images/no_data_found.png'

function NofoundLoader() {
    return (
        <div className="nofoundloader">
            <div>
                <img src={NofoundImg} alt="no dada found" />
                <p style={{color:'#000',fontWeight:'500'}}>No Data Found</p>
                <p>No data available in table.</p>
            </div>
        </div>
    )
}
export default NofoundLoader;
